import { useState } from 'react';

export default function DetailSynopsis({text,className = ''}) {
  const [expanded,setExpanded] = useState(false);
  return <div className={`detail-synopsis ${expanded ? 'is-expanded' : ''}`}><p className={className}>{text || 'A synopsis has not been added yet.'}</p>{text?.length > 220 && <button onClick={() => setExpanded(value => !value)} aria-expanded={expanded}>{expanded ? 'Show less' : 'Read full synopsis'}</button>}</div>;
}
